<div class="container">
  <div class="top-bar">
    <div class="back">
      <cs-icon-button iconType="icon" icon="fi-arrow-left" color="secondary" size="12" (buttonClick)="back()">
      </cs-icon-button>
    </div>
    <div class="title">{{ title }}</div>
    <div class="close">
      <cs-icon-button iconType="icon" icon="fi-x" size="12" color="secondary" (buttonClick)="close()"> </cs-icon-button>
    </div>
  </div>
  <div class="content">
    <img [src]="imgSrc" alt="" />
    <p class="intro">You are not logged into your {{ text }} in this device</p>
    <p class="text">Please log in or create a wallet if you don’t have one yet to continue.</p>
    <div class="dividers">
      <div class="divider"></div>
      <div class="divider-text">Or select another method to continue</div>
      <div class="divider"></div>
    </div>
    <app-third-auth-m8 type="wallet" (clickAuthName)="clickAuthName($event)"></app-third-auth-m8>
    <p class="help-text">
      Need help?
      <a href="#"> Contact support </a>
    </p>
  </div>
</div>
